import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import API from '../../services/API';
import { __ } from '@bart.sk-eshop/react-i18n';
import { withRouter, WithRouterProps } from 'react-router';
import { ErrorAlert } from '@bart.sk-eshop/eshop-defaults';
import { Loader } from '@bart.sk-eshop/eshop-defaults/lib';
import { LogoutButton } from './MyAccount';

const Wrapper = styled.div`
  width: 100%;
  max-width: ${rem(320)};
  padding: ${rem(25)};
  background-color: white;
  margin: ${rem(30)} auto 0;
  border-radius: ${rem(4)};
`;

const EmailWrapper = styled.div`
  margin-bottom: ${rem(10)};
`;

const AuthButtonWrapper = styled.div`
  margin-bottom: ${rem(25)};
`;

const SuccessTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(25)};
`;

const PasswordInput = styled.input<{ isMobile: boolean }>`
  display: block;
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  border-radius: ${rem(2)};
  padding: ${rem(16)};
  box-shadow: ${({ theme }) => theme.boxShadow.input};
  border: ${({ isMobile }) => (isMobile ? 'none' : '1px solid #cccccc')};
  height: ${rem(48)};
  max-width: ${({ isMobile }) => (isMobile ? 'initial' : rem(450))};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 300;
  font-family: ${({ theme }) => theme.font.secondary};

  &:disabled {
    cursor: not-allowed;
  }

  &::placeholder {
    font-family: ${({ theme }) => theme.font.secondary};
    color: ${({ theme }) => theme.colors.placeholder};
    font-weight: 300;
  }
`;

const Title = styled.h1`
  font-size: ${rem(30)};
  font-weight: 400;
  position: relative;
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(32)};
  line-height: ${rem(38)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

interface NewPasswordBoxPropsIO {
  token: string;
  onOk: () => void;
  onSignUpLinkClick: () => void;
  dispatch: (a: any) => void;
}

interface State {
  password: string;
  error: string;
  passwordChanged: boolean;
  fetching: boolean;
}

class NewPassword extends React.Component<
  NewPasswordBoxPropsIO & WithRouterProps,
  State
> {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      error: '',
      passwordChanged: false,
      fetching: false,
    };
  }

  public onSetPasswordClick = async () => {
    try {
      this.setState({ fetching: true });
      await API.newPassword(
        {},
        { new_password: this.state.password },
        { xLostPasswordToken: this.props.params.token },
      );
      this.setState({ passwordChanged: true, fetching: false });
    } catch (exp) {
      this.setState({ error: exp.details.description, fetching: false });
    }
  };

  public onPasswordChanged = e => {
    this.setState({ password: e.target.value });
  };

  public onOk = () => {
    this.setState({ passwordChanged: false, error: '' });
    this.props.router.push('/');
  };

  public render() {
    const { password, error, fetching } = this.state;
    return (
      <Loader loading={fetching}>
        <Wrapper>
          {!this.state.passwordChanged ? (
            <div>
              {error ? <ErrorAlert message={error} /> : ''}
              <Title>{__('Zmena hesla')}</Title>
              <EmailWrapper>
                <PasswordInput
                  type="password"
                  placeholder={__('Nové heslo')}
                  onChange={this.onPasswordChanged}
                  value={password}
                  name="new-password"
                />
              </EmailWrapper>

              <AuthButtonWrapper>
                <LogoutButton onClick={this.onSetPasswordClick}>
                  {' '}
                  {__('Zmeniť heslo')}{' '}
                </LogoutButton>
              </AuthButtonWrapper>
            </div>
          ) : (
            <div>
              <SuccessTextWrapper>
                {__('Heslo bolo úspešne aktualizované')}
              </SuccessTextWrapper>
              <AuthButtonWrapper>
                <LogoutButton onClick={this.onOk}> OK </LogoutButton>
              </AuthButtonWrapper>
            </div>
          )}
        </Wrapper>
      </Loader>
    );
  }
}

export default withRouter(NewPassword);
